import React from "react";
import { Box, Button } from "@mui/material";
import useStyles from "assets/jss/material-react/views/italmundoStyles";

export function ErrorLlamada({ handleClickBtn, showBtn }) {
  const classes = useStyles();
  return (
    <Box className={classes.modalContentDynamic}>
      <h3 style={{ color: "red" }} className={classes.modalTitle}>
        ERROR DE SISTEMA
      </h3>
      <p className={classes.modalMessage}>
        En estos momentos{" "}
        <strong>
          no podemos procesar tu solicitud. Volvé a intentarlo más tarde.
        </strong>{" "}
      </p>
      <p className={classes.modalMessage}>¡Muchas gracias!</p>
      {showBtn && (
        <div className={classes.divBtn} style={{ marginTop: "1rem" }}>
          <Button
            className={`${classes.btnFull} ${classes.btnAzul}`}
            variant="text"
            onClick={() => handleClickBtn()}
            sx={{
              width: "100%",
              backgroundColor: "#FFFF",
            }}
          >
            {"QUIERO QUE ME LLAMEN"}
          </Button>
        </div>
      )}
    </Box>
  );
}

export default Error;
